export class SetFrameLoadedStatus {
  public static readonly type = '[IFrame] Change status';
  constructor(public loaded: boolean) {}
}
export class ChangeFrameLocalStorage {
  public static readonly type = '[IFrame] Change Frame Local Storage';
  constructor(public payload: Record<string, any>, public delay?: number) {}
}
